import * as React from 'react';

import {motion} from 'framer-motion';

import type {PageChangeDirection} from 'shells/onboarding-modal/types';

import {Pipeline} from './pipeline';

import styles from './graphic-pipeline.module.css';

type Props = {
    direction: PageChangeDirection;
};

export class GraphicPipeline extends React.PureComponent<Props> {
    render() {
        const shouldAnimate = this.props.direction === 'forward';

        return (
            <div className={styles['graphic-container']}>
                <div className={styles.graphic}>
                    <Pipeline>
                        <motion.g
                            id='lead-card'
                            animate={{
                                translateX: 238,
                                translateY: shouldAnimate ? [67, 90, 67] : 67,
                            }}
                            transition={{
                                delay: 0.5,
                                duration: 0.8,
                                ease: 'easeInOut',
                            }}
                            initial={
                                shouldAnimate && {
                                    translateX: 122,
                                    translateY: 67,
                                }
                            }
                        >
                            <rect
                                id='shadow'
                                fillOpacity='.4'
                                fill='#000'
                                fillRule='nonzero'
                                filter='url(#filter-1)'
                                y='2'
                                width='100'
                                height='36'
                                rx='3.403'
                            />
                            <rect
                                fill='#FFF'
                                fillRule='nonzero'
                                x='1'
                                width='100'
                                height='36'
                                rx='3.403'
                            />
                            <text
                                id='ArrowGrid'
                                fontFamily='IBM Plex Sans'
                                fontSize='11'
                                fill='#4A4A4A'
                            >
                                <tspan x='38.82' y='23'>
                                    ArrowGrid
                                </tspan>
                            </text>
                            <path
                                id='Path'
                                stroke='#3b9ed7'
                                strokeWidth='2'
                                fill='#3b9ed7'
                                fillRule='nonzero'
                                strokeLinejoin='round'
                                d='M10 11l3.667 6.875L10 24.75h18.333L32 17.875 28.333 11z'
                            />
                        </motion.g>
                    </Pipeline>
                </div>
            </div>
        );
    }
}
